import {CdnLibrary} from "../const/common";
import {Toast} from 'mint-ui';
import store from "./store";

class GameData {
}

/*
if(window.location.href.indexOf("test-")>-1){
  GameData.releaseUrl = "test-m.66rpg.com/h5/v2/";
}else{
  GameData.releaseUrl = "m.66rpg.com/h5/v2/";
}
*/

GameData.getSrcByItem = function (item) {
  return CdnLibrary.CDNRES + item.rs_url.substr(0, 2) + '/' + item.rs_url;
};

GameData.getNameByItem = function (item) {
  return item.file_name;
};

GameData.AddBackGround = function (item) {
  let f_name = item.file_name;
  let f_size = item.file_size;
  let f_url = item.rs_url;
  Middle.ResMap.add(f_name, f_size, f_url);
};

GameData.AddMapRes = function (f_name, f_size, f_url, file_path) {
  Middle.ResMap.add(f_name, f_size, f_url, file_path);
};

//0为文本，1为图片，2为音乐
GameData.AddText = function (name, item, mood = 0, type, site) {
  let text = "";
  switch (type) {
    case 0:
      text = item;
      break;
    case 1:
      // name += name;
      text = item.file_name;
      this.AddMapRes(item.file_name, item.file_size, item.rs_url, Middle.FileType.PictureChat);
      break;
    case 2:
      // name += "se/" + name;
      text = this.getSrcByItem(item);
      // debugger;
      this.AddMapRes(item.file_name, item.file_size, this.getSrcByItem(item), Middle.FileType.MusicPop);
      break;
  }

  Middle.MiddleData.AddText(name, text, mood, site, type);
  if (type === 0) {
    store.state.editMsgText = '';
  }
};

GameData.enterChapter = function (index) {
  store.state.editMsgText = '';
  store.state.editText = false;
  Middle.MiddleCommand.enterChapter(index);
};

GameData.delEvent = function (type) {
  Middle.MiddleData.DeleteEvent(type);
};

GameData.AddEvent = function (type, para, index) {
  Middle.MiddleData.AddEvent(type, para, index);
};

GameData.setChapterConfig = function (conf) {
  let bg_name;

  if (conf.bg) {
    bg_name = "background/" + conf.bg.file_name;
    let bg_size = conf.bg.file_size;
    let bg_md5 = conf.bg.rs_url;

    bg_name = bg_name.toLowerCase();
    Middle.ResMap.add(bg_name, bg_size, bg_md5, Middle.FileType.PictureNormal);
  } else {
    bg_name = "";
  }

  let bgm_name, _bgmConf;
  if (conf.bgm) {
    _bgmConf = conf.bgm.rs_data[0];
    bgm_name = "bgm/" + _bgmConf.file_name;
    let bgm_size = _bgmConf.file_size;
    let bgm_md5 = _bgmConf.rs_url;
    Middle.ResMap.add(bgm_name, bgm_size, bgm_md5, Middle.FileType.MusicNormal);
  } else {
    bgm_name = "";
  }
  return {bg_name, bgm_name}
};

GameData.AddChapter = function (name, _chapterConfig, _model, _roles) {
  let _conf = GameData.setChapterConfig(_chapterConfig);

  return Middle.MiddleData.AddChapter(name, _conf.bg_name, _conf.bgm_name, _model, _roles);
};
GameData.openPreview = function (url) {
  let a = document.createElement('a');
  a.href = url;
  a.target = "_blank";
  a.click();
};

export {GameData}



// WEBPACK FOOTER //
// ./src/store/GameData.js